/**
 * Manager badge — shown next to a staff member's name in StaffList rows
 * and on the StaffDetail header when the staff currently holds the
 * manager role at a location. Indigo so it visually differs from the
 * StaffStatusBadge (active / scheduled / inactive) and the amber
 * "No app access" pill.
 */
export function ManagerBadge({ locationName }: { locationName?: string }) {
  return (
    <span
      className="inline-flex items-center rounded-full bg-indigo-100 px-2 py-0.5 text-xs font-medium text-indigo-700"
      title={locationName ? `Manager at ${locationName}` : 'Pharmacy manager'}
    >
      Manager
      {locationName ? <span className="ml-1 opacity-75">· {locationName}</span> : null}
    </span>
  );
}
